import { withTranslation } from 'react-i18next';
import CatalogPage from './CatalogPage';

export default withTranslation()(CatalogPage);
